<template>

    <section class="w-100 h-100">

        <!-- Loading -->
        <loading/>

        <!-- Workwithus List -->
        <template v-if="Object.values(alldata).length > 0">
    
            <div class="d-flex flex-row justify-content-between order-1">
                <h2 class="order-1">Workwithus List</h2>
                <strong class="order-2">Os dados serão automaticamente removidos em {{ rgpddatelimit.replace('day', 'dias') }} a contar da data de criação do contato, de acordo com as normas vigentes do RGPD.</strong>
            </div>
            
            <!-- Contact List Render -->
            <table-element :classname="['table-striped', 'order-2', 'my-3']">

                <!-- THead -->
                <template #thead>
                    <tr>
                        <th scope="col">#</th>
                        <th scope="col">Name</th>
                        <th scope="col">Email</th>
                        <th scope="col">Phone</th>
                        <th scope="col">Location</th>
                        <th scope="col">Candidatura</th>
                        <th scope="col">Curriculum</th>
                        <th scope="col">Portfólio</th>
                        <th scope="col">Portfólio Link</th>
                        <th scope="col">Status</th>
                        <th scope="col">Observação</th>
                        <th scope="col">Atualizado por</th>
                        <th scope="col">Created</th>
                        <th scope="col">Updated</th>
                        <!-- <th scope="col">SoftDelete</th> -->
                        <th scope="col">Actions</th>
                    </tr>
                </template>

                <!-- Tbody -->
                <template #tbody>

                    <tr v-for="(value, index) in alldata" :key="value.id" :data-referid="index" :data-workwithusid="value.id">
                        <th scope="row">{{ value.id }}</th>
                        <td>{{ value.firstname }} {{ value.lastname }}</td>
                        <td>{{ value.email }}</td>
                        <td><a :href="`tel:+351${value.phone}`">{{ value.phone }}</a></td>
                        <td>{{ value.location }}</td>
                        <td>{{ value.department }}</td>
                        <td>
                            <a 
                            :href="storagelink + '/' + value.id + '/' + downloadStructure(JSON.parse(value.workcv)).filenamenew" 
                            :download="downloadStructure(JSON.parse(value.workcv)).filenameold"
                            target="_self"
                            >
                                {{ downloadStructure(JSON.parse(value.workcv)).filenameold }}
                            </a>
                        </td>
                        <td>
                            <a
                            v-if="value.workportfolio !== null" 
                            :href="storagelink + '/' + value.id + '/' + downloadStructure(JSON.parse(value.workportfolio)).filenamenew" 
                            :download="downloadStructure(JSON.parse(value.workportfolio)).filenameold"
                            target="_self"
                            >
                                {{ downloadStructure(JSON.parse(value.workportfolio)).filenameold }}
                            </a>
                        </td>
                        <td><a :href="value.portfoliolink" target="_blank" aria-describedby="Access Portfolio Link">{{ value.portfoliolink }}</a></td>
                        <td>
                            <select 
                                class="form-select selectstates selectstatestable" 
                                id="selectstatestable" 
                                aria-label="State Select" 
                                style="width:10rem;"
                                :data-referid="index"
                                @change="buttonsAction($event, 'state')"
                            >
                                <option 
                                    v-for="(valstate, indexstate) in stateslist" 
                                    :key="indexstate" 
                                    :value="valstate"
                                    :selected="value.state === valstate"
                                >
                                    {{  valstate }}
                                </option>
                            </select>
                        </td>
                        <td>
                            <button @click="showModalObs($event, value.id, value.interview)" type="button" class="btn btn-primary">
                                <p v-if="value.interview === null">Add</p>
                                <p v-else>Edit</p>
                            </button>
                        </td>
                        <td>{{ value.name === null ? '' : value.name }}</td>
                        <td>{{ value.created_at }}</td>
                        <td>{{ value.updated_at !== null ? value.updated_at : '' }}</td>
                        <td>{{ value.deleted_at !== null ? value.deleted_at : '' }}</td>
                        <td class="d-flex flex-row justify-content-between">
                            <button class="btn btn-primary" @click="showModal($event)" data-action="2">Responder</button>
                            
                            <!--
                            <template v-if="value.deleted_at === null">
                                <button class="btn btn-danger" type="button" @click="buttonsAction($event, 'softdelete')" data-action="3">Delete</button>
                            </template>
                            
                            <template v-else>
                                <button class="btn btn-info" type="button" @click="buttonsAction($event, 'restore')" data-action="4">Restore</button>
                            </template> -->
                            
                            <button v-if="parseInt(userrule) === 1" 
                                class="btn btn-danger" 
                                type="button" 
                                @click="buttonsAction($event, 'remove')" 
                            data-action="5">Remove</button>

                        </td>
                    </tr>

                </template>

            </table-element>

        </template>

        <template v-else>

            <span>Nenhuma candidatura foi feito pelo website</span>

        </template>

        <!-- Modal for Form Response -->
        <modal
            title="Send Response"
            classname="formsendresponse"
        >

            <template #modalcontent>

                <div class="d-flex flex-column">

                    <div class="order-1 d-flex flex-row justify-content-between">

                        <span class="order-1">Indicate Status</span>

                        <select class="form-select selectstates selectstatesmodal order-2" id="selectstatesmodal" aria-label="State Select" style="width:10rem;">
                            <option selected>Selecionar</option>
                            <option 
                                v-for="(valstate, indexstate) in stateslist" 
                                :key="indexstate" 
                                :value="valstate"
                            >
                                {{  valstate }}
                            </option>
                        </select>

                    </div>

                    <!-- Email Structure -->
                    <span class="my-3 order-2">
                        <strong style="padding-right: 1rem;">Para:</strong>{{ emailto }}</span>
                    <span class="my-3 order-4">
                        <strong style="padding-right: 1rem;">Assunto:</strong>
                        <input type="text" v-model="emailsubject" id="emailsubject" class="emailsubject pr-2" style="width:82.5%;" />
                    </span>
                    <div class="order-4 my-3">

                        <label for="emailnewmessage" class="form-label">Mensagem:</label>
                        <textarea class="form-control emailnewmessage" @focusin="inputValidation($event, 'emailnewmessage')" @focusout="inputValidation($event, 'emailnewmessage')"  v-model="emailnewmessage" maxlength="2000" id="emailnewmessage" rows="3" aria-describedby="Message to email response" required></textarea>

                    </div>

                    <button class="btn btn-primary order-5" @click="buttonsAction($event, 'response')" data-action="3" :disabled="disabled">Enviar</button>

                </div>

            </template>

        </modal>
        
        <!-- Add Observations about candidate -->
        <modal
            title="Add or Edit Candidate Observation"
            classname="formcandidateobs"
        >

            <template #modalcontent>

                <div class="d-flex flex-column">

                    <div class="mb-3 candidateobsbase order-1 d-flex flex-column">
                        <label for="candidateobs" class="form-label"><b>Observações:</b></label>
                        <textarea 
                            class="order-1 mt-3 candidateobs" 
                            name="candidateobs" 
                            id="candidateobs" 
                            v-model="candidateobs"
                            @focusin="inputValidation($event, 'candidateobs')" 
                            @focusout="inputValidation($event, 'candidateobs')"
                        >
                            {{ candidateobs }}
                        </textarea>
                    </div>

                    <div class="order-2 mt-3 d-flex flex-row justify-content-end">

                        <button type="button" class="btn btn-primary" @click="buttonsAction($event, 'updateobs')" :disabled="disabledobs">Submit</button>

                    </div>

                </div>

            </template>
        
        </modal>

        <!-- Response Messages -->
        <div class="order-3 responsebasemessage" ref="responsebasemessage">
    
            <list-message/>

        </div>

    </section>

</template>
<script>

import htmlElements from './../../htmlElements.js';
import fetchData from './../../fetchData.js';
import validation from './../../inputValidation.js';
import ListMessage from './../elements/ListMessageElement.vue';
import Loading from './../elements/LoadingElement.vue';
import Table from './../elements/TableElement.vue';
import Modal from './../elements/ModalElement.vue';

//Set Use Strict
"use strict";

export default{
    name: 'WorkwithusComponent',
    props:{

        csrftolken:{
            type: String,
            required: true
        },
        allcandidates:{
            type: String,
            required: true
        },
        userrule:{
            type: String,
            required: true
        },
        rgpddatelimit:{
            type: String,
            required: true
        },
        storagelink:{
            type: String,
            required: true
        },
        workwithusresponse:{
            type: String,
            required: true
        },
        listofstates:{
            type: String,
            required: true
        },
        workwithusstate:{
            type: String,
            required: true
        },
        workwithussoftdelete:{
            type: String,
            required: true
        },
        workwithusrestore:{
            type: String,
            required: true
        },
        workwithusdelete:{
            type: String,
            required: true
        },
        workwithusobs:{
            type: String,
            required: true
        }

    },
    data: () => {

        return{

            disabledobs: true,
            disabled: true,
            activeclass: 'd-flex',
            alldata: {},
            formaction: "",
            emailto: '',
            emailsubject: '',
            emailnewmessage: '',
            workwithusid: '',
            candidatestate: '',
            buttonsaction: {},
            fullname: '',
            listidinputs: [],
            stateslist: {},
            candidateobs: '',

        }

    },
    created(){

        //Set Workwithus Data
        this.alldata = JSON.parse(this.allcandidates);

        //Set List of States
        this.stateslist = JSON.parse(this.listofstates);

    },
    mounted(){


    },
    methods:{

        downloadStructure(fileobject){

            //Check filedata
            if(fileobject !== null){

               
                return fileobject;

            }
            
        
        },
        resumeMessage(text, limit, divisor){

            //console.log(text);
            if(text !== undefined){

                let resume = text.length > limit ?
                `${text.substr(0, Math.round(text.length / divisor))}...` : text;

                return resume;

            }

        },
        showModal(element){

            //Get Index from List
            let parentReferId = element.currentTarget.parentElement.parentElement.getAttribute('data-referid');

            //Get Values from List
            let currentItem = Object.values(this.alldata).find((value, index) => index === parseInt(parentReferId));

            //Subject Structure
            let subject = currentItem.department.includes('Candidatura') ? currentItem.department : "Candidatura " + currentItem.department;

            //Set Data for sendmail
            this.workwithusid = currentItem.id;
            this.emailto = currentItem.email;
            this.emailsubject = "RE: " + subject;
            this.fullname = currentItem.firstname + ' ' + currentItem.lastname;
            this.candidatestate = currentItem.state;

            //Show Modal
            $(".formsendresponse").modal("show");

            return;

        },
        showModalObs(element, id, text){

            //Set Data
            this.workwithusid = id;
            this.candidateobs = text || text !== null ? text : '';

            //Show Modal
            $(".formcandidateobs").modal("show");

        },
        hideModal(classname){

            //Hide Modal 
            $(`.${classname}`).modal("hide");

        },
        inputValidationMethod(validationtype, inputvalue, inputid = ''){

            //Instance Validation
            let inputValidation = new validation(validationtype, '', '');

            //Validation Method
            let validInput;

            //Set Method
            switch(validationtype)
            {
                //Input Validation only for numbers
                case 2:
                    validInput = inputValidation.validNameCases(validationtype, inputvalue);
                
                break;

                //Input Validation All Types of data
                case 4:
                    validInput = inputValidation.validNameCases(validationtype, inputvalue);
                break;

                //Email Validation
                case 7:

                    let emailRegex = new RegExp(/^[A-Za-z0-9_!#$%&'*+\/=?`{|}~^.-]+@[A-Za-z0-9.-]+$/, "gm");
                    validInput = emailRegex.test(inputvalue);
                    
                break;
                
                //URL Validation
                case 8:
                    validInput = inputValidation.isValidUrl(inputvalue, inputid);
                break;

            }

            return validInput;

        },
        inputValidation(element, inputid){

            //Check Value
            if(element.currentTarget.value !== ''){

                //Check by inputid
                switch(inputid)
                {

                    //emailnewmessage 
                    case 'emailnewmessage':   

                        //Check Validation
                        this.disabled = this.inputValidationMethod(4, element.currentTarget.value) === true ? false : true;

                        //Check Error
                        if(this.disabled){

                            //Set Id for Error Generate
                            this.listidinputs.push(inputid)

                            //Generate Error Message
                            this.dynamicErrorMessageGenerate(this.listidinputs);

                            //Clean Variable
                            this.listidinputs = [];

                        }

                    break;

                    //candidateobs
                    case 'candidateobs':
                        
                        //Check Validation
                        this.disabledobs = this.inputValidationMethod(4, element.currentTarget.value) === true ? false : true;

                        //Check Error
                        if(this.disabledobs){

                            //Set Id for Error Generate
                            this.listidinputs.push(inputid)

                            //Generate Error Message
                            this.dynamicErrorMessageGenerate(this.listidinputs);

                            //Clean Variable
                            this.listidinputs = [];

                        }
                    
                    break;

                }

                //Check Input id for return conditional
                if(inputid !== "candidateobs"){

                    return this.disabled;

                }else{

                    return this.disabledobs;

                }

            }

            //Check Input id for return conditional
            if(inputid !== "candidateobs"){

                return this.disabled;

            }else{

                return this.disabledobs;

            }

        },
        buttonsAction(element, action){

            //Get Current Item Data
            let currentItem = {};

            //Check Action
            if(action !== 'response'){

                //Get Index from List
                let parentReferId = action !== "state" ? 
                element.currentTarget.parentElement.parentElement.getAttribute('data-referid') : element.currentTarget.getAttribute('data-referid');

                //Get Values from List
                currentItem = Object.values(this.alldata).find((value, index) => index === parseInt(parentReferId));

            }

            //Set Formaction
            switch(action)
            {
                case 'updateobs':

                    //Check Candidate Observation text
                    if(this.candidateobs === ""){

                        //Send Error Message
                        alert("Favor informar todos os dados");

                        return this.disabledobs = true;

                    }

                    this.buttonsaction.id = this.workwithusid;
                    this.buttonsaction.formaction = 'updateobs';
                    this.buttonsaction.interview = this.candidateobs; 

                break;

                case 'state':
                    this.buttonsaction.id = currentItem.id;
                    this.buttonsaction.formaction = 'state';
                    this.buttonsaction.state = element.currentTarget.value;
                break;

                case 'softdelete':
                    this.buttonsaction.id = currentItem.id;
                    this.buttonsaction.formaction = 'softdelete';
                break;

                case 'restore':
                    this.buttonsaction.id = currentItem.id;
                    this.buttonsaction.formaction = 'restoresoftdelete';
                break;

                case 'response':

                    //Check Empty Value
                    if(this.emailnewmessage === "" || document.getElementById('selectstatesmodal').value === 'Selecionar'){

                        //Send Error Message
                        alert("Favor informar todos os dados");

                        return this.disabled = true;

                    }

                    //Set formaction
                    this.buttonsaction.id = this.workwithusid;
                    
                    //Set formaction
                    this.buttonsaction.formaction = 'response';

                    //Set Data To Send Mail
                    this.buttonsaction.emailto = this.emailto;
                    this.buttonsaction.emailsubject = this.emailsubject;
                    this.buttonsaction.clientname = this.fullname;
                    this.buttonsaction.emailnewmessage = this.emailnewmessage;
                    this.buttonsaction.state = document.getElementById('selectstatesmodal').value;

                break;

                case 'remove':

                    //Confirm
                    let confirmAction = confirm(`Are you sure do you want to ${action} this page?`);

                    //Check Confirm
                    if(!confirmAction){

                        return;

                    }

                    this.buttonsaction.id = currentItem.id;
                    this.buttonsaction.formaction = 'delete';
                    
                
                break;

            }

            //Send Data for delete
            return this.sendData(this.buttonsaction.formaction, this.buttonsaction);

        },
        dynamicErrorMessageGenerate(listIdInputs, timeout = 5000){

            //Show Error Messages
            if(listIdInputs.length > 0){

                //console.log(this.listidinputs);

                //Set id for error message
                listIdInputs.forEach((value) => {

                    //Instance Validation
                    let inputValidation = new validation(3, '', '');

                    //Set Uppercase
                    let firstLetter = value.at(0).toUpperCase();
                    let capitalizaValue = value.replace(value.at(0), firstLetter);

                    //Render Erro Message
                    inputValidation.createErrorMessageElement(value, `Please inform the correct format for ${capitalizaValue}`);

                });

                //Clean Variable
                this.listIdInputs = [];

                //console.log(this.listidinputs);

                //Clean Error Message
                setTimeout(function(){

                    //Clean all Error Messages
                    [...document.querySelectorAll('span.errorMessage')].forEach((value) => {

                        //Remove element
                        value.remove();

                    });

                }, timeout);

                //Disabled Submit
                //this.disabled = true;

                return this.listIdInputs;

            }

        },
        dataStructureResponse(responseObject){

            //Get Key and Value
            let entries = Object.entries(responseObject);

            //Response Value

            //Loop response conditional
            for(const [key, value] of entries){

                switch(key)
                {

                    case 'attListData':

                        //Set Data
                        this.alldata = value;

                        //Clean Data
                        this.emailto = '';
                        this.emailsubject = '';
                        this.emailnewmessage = '';
                        this.fullname = '';
                        this.candidatestate = '';
                        this.workwithusid = '';
                        this.candidateobs = '';
                        this.buttonsaction = {};

                        //Clean All Select from Modal
                        [...document.querySelectorAll('.selectstatesmodal')].forEach(val => val.value = "Selecionar");

                        //Close Modal
                        this.hideModal('formsendresponse');
                        this.hideModal('formcandidateobs');

                        //Enable BTN
                        this.disabled = false;
                        this.disabledobs = false;

                    break;

                    case 'successMessage':
                    case 'errorMessage':
                        
                        //Add active Class
                        this.$refs.responsebasemessage.classList.add(this.activeclass);
                        this.$refs.responsebasemessage.classList.add(key.toLowerCase());

                        //Set Messages List
                        value.forEach((valmessage) => {

                            //Element for append
                            let li = `<li class="list-group item my-1">${valmessage}</li>`;

                            //Append Element
                            $(li).appendTo(this.$refs.responsebasemessage.children);

                        });
                        

                    break;

                }

            }

            //Remove Base Response Message
            this.removeResponseMessages();

            return;

        },
        removeResponseMessages(time = 5000){

            setTimeout(function(){

                //Remove active class
                document.querySelector('.responsebasemessage').classList.remove('d-flex');
                document.querySelector('.responsebasemessage').classList.remove('successmessage');
                document.querySelector('.responsebasemessage').classList.remove('errormessage');

                //Remove children elements
                let ul = document.querySelector('.responsebasemessage').children;

                [...ul[0].children].forEach((valli) => {

                    //Remove Elements
                    valli.remove();

                });

            }, time);

        },
        sendData(formaction, data = null, element = null){

            //Disabled BTN
            this.disabled = true;
            this.disabledobs = true;

            //Active Loading
            document.querySelector('.loadingbase').classList.add('d-flex');

            //Structure Data Form
            let dataForm = {};

            //Set Route
            let method;
            let urlmethod; 

            switch(formaction)
            {
                //updateobs
                case 'updateobs':

                    method = 'PUT';
                    urlmethod = this.workwithusobs;
                    dataForm = data;

                break;

                //Update
                case 'response':

                    method = 'PUT';
                    urlmethod = this.workwithusresponse;
                    dataForm = data;

                break;

                //Delete
                case 'delete':

                    method = 'DELETE';
                    urlmethod = this.workwithusdelete;
                    dataForm = data;

                break;

                //Soft Delete
                case 'softdelete':

                    method = 'PUT';
                    urlmethod = this.workwithussoftdelete;
                    dataForm = data;

                break;

                //Restore Soft Delete
                case 'restoresoftdelete':

                    method = 'PUT';
                    urlmethod = this.workwithusrestore;
                    dataForm = data;

                break;

                //State
                case 'state':

                    method = 'PUT';
                    urlmethod = this.workwithusstate;
                    dataForm = data;

                break;

            }

            //console.log([method, urlmethod]);
            //console.log(Object.keys(dataForm));
            /* console.log(dataForm);
            return;
            */

            //Check Data Form
            if(Object.keys(dataForm).length > 0){

                //Send Data
                let response = fetchData.structureTosendData(urlmethod, dataForm, this.csrftolken, method);

                //Check Response
                response.then((value) => {

                    //Desactive Loading
                    document.querySelector('.loadingbase').classList.remove('d-flex');

                    //Enabled BTN
                    this.disabled = false;
                    this.disabledobs = false;

                    //Generate a Response
                    return this.dataStructureResponse(value);

                }).catch((error) => {

                    //Desactive Loading
                    document.querySelector('.loadingbase').classList.remove('d-flex');

                    //Enabled BTN
                    this.disabled = false;
                    this.disabledobs = false;

                    throw new Error(error);

                });

            }else{

                //Send Message
                alert('Por favor apenas enviar dados válidos');

                //Desactive Loading
                document.querySelector('.loadingbase').classList.remove('d-flex');

                //Enabled BTN
                this.disabled = false;
                this.disabledobs = false;

            }

            return;

        }

    },
    computed:{

        computedAllData(){

            return this.alldata;

        },
        computedEmailTo(){

            return this.emailto;

        },
        computedEmailSubject(){

            return this.emailsubject;

        },
        computedEmailMessage(){

            return this.emailmessage;

        },
        computedCandidateObs(){

            return this.candidateobs;

        }

    },
    watch:{

        computedAllData(){},
        computedEmailTo(){},
        computedEmailSubject(){},
        computedEmailMessage(){},
        computedCandidateObs(){}

    },
    components:{

        listMessage: ListMessage,
        loading: Loading,
        tableElement:Table,
        modal: Modal

    }

}

</script>